const notification = require('@assets/sounds/notification.mp3');
const notificationAudio = new Audio(notification);

export const playNotification = async () => {
    try {
        notificationAudio.play();
    } catch (e) {
        console.log(e);
    }
}